import { type ReactNode } from 'react';

interface HeroImageProps {
  children: ReactNode;
}

const HeroImage = ({ children }: HeroImageProps) => <div className="hero__image">{children}</div>;

export default HeroImage;
